import React, { Component } from 'react';
import AuthService from './AuthService';
import constants from '../config';

const Auth = new AuthService();

class ShareRedirect extends Component {
  componentDidMount() {
    const shareId = this.props.match.params.share_id;
    const endpoint = Auth.loggedIn()
      ? `${constants.DOMAIN}/api/v1/func/share/${shareId}`
      : `${constants.DOMAIN}/api/v1/guest/share/${shareId}`;

    const fetchOpts = Auth.loggedIn()
      ? { method: 'GET', headers: { Authorization: Auth.getAuthHeader() } }
      : { method: 'GET' };

    fetch(endpoint, fetchOpts)
      .then(res => res.json())
      .then(data => {
        const post = data.share && data.share.post;
        if (post && post._id) {
          this.props.history.replace(`/product/${post._id}?ref=${shareId}`);
        } else {
          this.props.history.replace('/');
        }
      })
      .catch(() => {
        this.props.history.replace('/');
      });
  }

  render() {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Redirecting...</p>
      </div>
    );
  }
}

export default ShareRedirect;
